// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","home":"MNxJb","logo":"w_mTy","mobileLogo":"_1gOr8","tabletLogo":"e1vQB","desktopLogo":"_3DlT2"};